var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 632,
    height: 632,
    viewBox: "0 0 632 632",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.333 102.667H444V81.3333C444 69.5573 434.464 60 422.667 60C410.869 60 401.333 69.5573 401.333 81.3333V102.667H230.667V81.3333C230.667 69.5573 221.131 60 209.333 60C197.536 60 188 69.5573 188 81.3333V102.667H166.667C107.851 102.667 60 150.517 60 209.333V465.333C60 524.149 107.851 572 166.667 572H465.333C524.149 572 572 524.149 572 465.333V209.333C572 150.517 524.149 102.667 465.333 102.667ZM166.667 145.333H465.333C500.619 145.333 529.333 174.048 529.333 209.333V230.667H102.667V209.333C102.667 174.048 131.381 145.333 166.667 145.333ZM465.333 529.333H166.667C131.381 529.333 102.667 500.619 102.667 465.333V273.333H529.333V465.333C529.333 500.619 500.619 529.333 465.333 529.333ZM465.333 358.667C465.333 370.443 455.797 380 444 380H188C176.203 380 166.667 370.443 166.667 358.667C166.667 346.891 176.203 337.333 188 337.333H444C455.797 337.333 465.333 346.891 465.333 358.667ZM316 444C316 455.776 306.464 465.333 294.667 465.333H188C176.203 465.333 166.667 455.776 166.667 444C166.667 432.224 176.203 422.667 188 422.667H294.667C306.464 422.667 316 432.224 316 444Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(60 60)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.6923c1a393cdd680c42e95dbece1d740.svg";
export { ForwardRef as ReactComponent };